import { CUSTOM_URL_VALUE } from '../components/AgentForm/const';

export const isHttpUrl = (value?: string | null): boolean => {
  if (!value) return false;
  return value.startsWith('http://') || value.startsWith('https://');
};

export const toFormBackgroundSound = (value?: string | null) => {
  if (isHttpUrl(value)) {
    return { sound: CUSTOM_URL_VALUE, customUrl: value ?? null };
  }
  return { sound: value ?? null, customUrl: null };
};

export const toApiBackgroundSound = (
  sound?: string | null,
  customUrl?: string | null
): string | null => {
  if (sound === CUSTOM_URL_VALUE) return customUrl || null;
  return sound || null;
};
